<template>
  <custom-callout
    :border-color="borderColor"
    class="callout"
    :has-toggle="false"
  >
    <validation-observer ref="evalutatorFromRef">
      <div class="row mt-2 row-container py-4">
        <div class="col-md-2 col-12 border-right status">
          <div class="row">
            <div class="col-12 d-none d-md-block">
              <div class="label">Nombre:</div>
              <span class="info">
                {{ value.fullName | capitalize }}
              </span>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-10">
          <div class="row">
            <div class="col-12 d-block d-md-none">
              <div class="label">Nombre:</div>
              <span class="info">
                {{ value.fullName }}
              </span>
            </div>
            <div class="col-12 col-md-2">
              <div class="label">Usuario:</div>
              <span class="info">
                {{ value.user.name }}
              </span>
            </div>
            <div class="col-12 col-md-2">
              <div class="label">Rol:</div>
              <span class="info">
                {{ value.role.name }}
              </span>
            </div>
            <div class="col-12 col-md-3">
              <div class="label">Tipo de Propuesta:</div>
              <span v-if="!available && !isEditing" class="info">
                {{ value.proposalServiceEvaluatorType }}
              </span>
              <validation-provider
                v-if="!available && isEditing"
                v-slot="{ errors }"
                rules="required"
              >
                <custom-drop-down
                  v-model="proposalServiceEvaluatorType"
                  custom-error-msg="Tipo de Propuesta es requerido."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="proposalTypes"
                  placeholder="Seleccione"
                />
              </validation-provider>
              <validation-provider
                v-if="available && !isEditing"
                v-slot="{ errors }"
                rules="required"
              >
                <custom-drop-down
                  v-model="value.proposalServiceEvaluatorType"
                  custom-error-msg="Tipo de Propuesta es requerido."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="proposalTypes"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>
            <div class="col-12 col-md-3">
              <div class="label">Tipo de Proveedor:</div>
              <span v-if="!available && !isEditing" class="info">
                {{ value.proposalProviderType }}
              </span>
              <validation-provider
                v-if="!available && isEditing"
                v-slot="{ errors }"
                rules="required"
              >
                <custom-drop-down
                  v-model="proposalProviderType"
                  custom-error-msg="Tipo de Proveedor es requerido."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="providerTypes"
                  placeholder="Seleccione"
                />
              </validation-provider>
              <validation-provider
                v-if="available && !isEditing"
                v-slot="{ errors }"
                rules="required"
              >
                <custom-drop-down
                  v-model="value.proposalProviderType"
                  custom-error-msg="Tipo de Proveedor es requerido."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="providerTypes"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>
            <div
              class="col-12 col-md-2 d-flex justify-content-center align-items-start"
            >
              <action-button
                v-if="
                  isVisibleDeleteButton(value.academicYearId) &&
                    !available &&
                    !isEditing
                "
                class="outline-danger py-1"
                i="fa fa-times-circle"
                @click="onRemoveHandler(value, index)"
              >
                Remover
              </action-button>
              <action-button
                v-if="available"
                class="outline-success py-1"
                i="fa fa-plus"
                @click="onAddHandler(value, index)"
              >
                Añadir
              </action-button>
              <action-button
                v-if="canEdit && !isEditing && !available"
                class="outline-success py-1 ml-2 mr-4"
                i="fa fa-edit"
                @click="edit(value)"
              >
                Editar
              </action-button>
              <action-button
                v-if="isEditing && !available"
                class="outline-danger py-1 mr-2"
                i="fa fa-times-circle"
                @click="cancelEdit()"
              >
                Cancelar
              </action-button>
              <action-button
                v-if="isEditing && !available"
                class="outline-success py-1 mr-4"
                i="fa fa-save"
                @click="onEditHandler(value, index)"
              >
                Guardar
              </action-button>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </custom-callout>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomCallout from 'custom-callout';
import { Colors } from '@/components/common';

export default {
  name: 'EvaluatorRowStandard',
  components: { CustomDropDown, CustomCallout, ActionButton },
  props: {
    colorBallon: {
      type: String,
      default: () => 'gray',
    },
    value: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: null,
    },
    available: {
      type: Boolean,
      default: false,
    },
    isVisibleDeleteButton: {
      type: Function,
      default: () => false,
    },
    proposalTypes: {
      type: Array,
      default: () => [],
    },
    providerTypes: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    isEditing: false,
    proposalProviderType: null,
    proposalServiceEvaluatorType: null,
  }),
  computed: {
    borderColor() {
      return this.available ? null : Colors.GREEN;
    },
    canEdit() {
      return this.userHasPermissions('proposal.selectedevaluators.edit');
    },
  },
  mounted() {
    this.proposalProviderType = this.providerTypes.find(
      (x) => x.name == this.value.proposalProviderType
    );

    this.proposalServiceEvaluatorType = this.proposalTypes.find(
      (x) => x.name == this.value.proposalServiceEvaluatorType
    );
  },
  created() {},
  methods: {
    onRemoveHandler(item, index) {
      this.$emit('remove', { item, index });
    },
    async onAddHandler(item, index) {
      const isValid = await this.$refs.evalutatorFromRef.validate();
      if (!isValid) {
        this.Toast('Alerta', 'Información incompleta.', 'error', 5000);
        return;
      }
      this.$emit('add', { item, index });
    },
    async onEditHandler(item, index) {
      const isValid = await this.$refs.evalutatorFromRef.validate();
      if (!isValid) {
        this.Toast('Alerta', 'Información incompleta.', 'error', 5000);
        return;
      }
      const data = {
        academicYearId: item.academicYearId,
        proposalProviderType: {
          id: this.proposalProviderType.id,
          name: this.proposalProviderType.name,
        },
        proposalServiceEvaluatorType: {
          id: this.proposalServiceEvaluatorType.id,
          name: this.proposalServiceEvaluatorType.name,
        },
        user: {
          id: item.user.id,
          name: item.user.name,
        },
      };
      this.cancelEdit();

      this.$emit('edit', { item: data, index });
    },
    edit() {
      this.isEditing = true;
    },
    cancelEdit() {
      this.isEditing = false;
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/fonts.scss';
@import '~@/shared/scss/config/colors.scss';

.label {
  font-weight: normal;
  font-size: 0.875rem;
  color: map-get($colors, 'secondary-6');
}

.info {
  font-weight: normal;
  color: map-get($colors, 'black');
}

@media only screen and (max-width: 768px) {
  .actions-dropdown {
    ::v-deep {
      .dropdown-toggle {
        width: 100%;
        font-size: 0.875rem;
      }
    }
  }
}
</style>
